module.exports = __webpack_public_path__ + "img/box-remove.2108c3ec.svg";